export const UPLOAD_VIDEO ="UPLOAD_VIDEO";
export const VIDEO_PROGRESS = "VIDEO_PROGRESS";
export const RESET_UPLOAD_VIDEO = "RESET_UPLOAD_VIDEO";
export const RESET_PROGRESS_STATUS = "RESET_PROGRESS_STATUS";
export const UPLOAD_AUDIO = "UPLOAD_AUDIO";
export const AUDIO_PROGRESS = "AUDIO_PROGRESS";
export const RESET_UPLOAD_AUDIO = "RESET_UPLOAD_AUDIO";
export const RESET_PROGRESS_STATUS_AUDIO = "RESET_PROGRESS_STATUS_AUDIO";
export const SEARCH_FILTER_DATA = "SEARCH_FILTER_DATA";
export const RESET_SEARCH_FILTER_DATA = "RESET_SEARCH_FILTER_DATA";
export const UPDATE_BOOKMARK = "UPDATE_BOOKMARK";
export const CONFIG_SET = "CONFIG_SET";